import React from "react";
import TotemFooter from "../TotemFooter/TotemFooter";
import {
  ButtonsArea,
  Container,
  ContentArea,
  Header,
} from "./TotemSkeletonStyles";

interface Props {
  title: string;
  buttons: React.ReactNode;
  children: React.ReactNode;
}

const TotemSkeleton: React.FC<Props> = ({ title, buttons, children }) => {
  return (
    <Container>
      <Header>
        <h1>{title}</h1>
      </Header>
      <ContentArea>{children}</ContentArea>
      <ButtonsArea>{buttons}</ButtonsArea>
      <TotemFooter />
    </Container>
  );
};

export default TotemSkeleton;
